import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  Row
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';
import { useRouter } from 'vue-router/composables';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';
import { moneyFormat } from '@/modules/common/helpers/currency';


export default /*#__PURE__*/_defineComponent({
  __name: 'Investment',
  setup(__props) {

const changeAmountValue = inject(
  'changeAmountValue',
  (value: number, formatted: string) => ({ value, formatted })
);

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const router = useRouter();
const amountFormatted = ref('');
const amountValue = ref(0);

const isDisabled = computed(() => {
  return amountValue.value <= 0 || status.value === 'error';
});

const minimumInvestment = computed(() => {
  return investmentDetails.value.minimumInvestment.value;
});

const availableBalance = computed(() => {
  return investmentDetails.value.availableBalance.value;
});

const hasBalance = computed(() => {
  return investmentDetails.value.availableBalance.value > 0;
});

const totalAfterInvestment = computed(() => {
  return moneyFormat(
    investmentDetails.value.portfolioBalance.value + amountValue.value
  );
});

const headerValueClass = computed(() => {
  return hasBalance.value ? '' : 'investment-step__header--value';
});

const balanceValue = computed(() => {
  return hasBalance.value
    ? investmentDetails.value.availableBalance.formatted
    : 'Depositar';
});

function redirectToDeposit() {
  if (hasBalance.value) return;

  router.push({ name: 'deposit-pix' });
}

const status = computed(() => {
  return (amountValue.value < minimumInvestment.value &&
    amountValue.value !== 0) ||
    amountValue.value > availableBalance.value
    ? 'error'
    : '';
});

const helperText = computed(() => {
  if (amountValue.value < minimumInvestment.value && amountValue.value !== 0)
    return `O valor mínimo de investimento nesta carteira é ${investmentDetails.value.minimumInvestment.formatted}`;
  if (amountValue.value > availableBalance.value)
    return `Valor maior que o saldo disponível: ${investmentDetails.value.availableBalance.formatted}`;

  return '';
});

function investClick() {
  changeAmountValue(amountValue.value, amountFormatted.value);
}

function onChangeValue(data: { value: number; formatted: string }) {
  amountFormatted.value = data.formatted;
  amountValue.value = data.value;
}

return { __sfc: true,changeAmountValue, investmentDetails, router, amountFormatted, amountValue, isDisabled, minimumInvestment, availableBalance, hasBalance, totalAfterInvestment, headerValueClass, balanceValue, redirectToDeposit, status, helperText, investClick, onChangeValue, HeadingDisplay, BaseText, ListDisplay, ButtonContainer, ButtonPrimary, Row, NebraskaColors, SingleInputMoney }
}

})